export default [
  {
    path: '/',
    component: () => import('./Dashboard.vue'),
    children: [
      { path: '/', component: () => import('./ActiveBrews.vue') },
      { path: '/history', component: () => import('./History.vue') },
      // Hidden brews became Archived, and live in History.
      { path: '/archived', redirect: { path: '/history', query: { show: 'archived' } } },
      { path: '/new', component: () => import('./CreateNew.vue') },
    ],
  },
];
